import { useEffect, useState } from "react";
import { apiMongo } from "../api/apiData";
import { toast } from "react-toastify";

// Wartość początkowa zanim doładuje się realna cena z serwera (edytowalna
// per gra w panelu admina) - tylko żeby uniknąć migotania "0 zł" na starcie
const FALLBACK_CERTIFICATE_PRICE = 10;

export const SupportShelterPage = () => {
  const [buyerName, setBuyerName] = useState("");
  const [email, setEmail] = useState("");
  const [quantity, setQuantity] = useState(1);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [certificatePrice, setCertificatePrice] = useState(
    FALLBACK_CERTIFICATE_PRICE
  );

  useEffect(() => {
    const fetchCertificatePrice = async () => {
      try {
        const response = await apiMongo.get(
          `${process.env.REACT_APP_MONGO_URL}/game/certificate-price`
        );
        setCertificatePrice(response.data.certificatePrice);
      } catch (error) {
        console.error("Cannot get certificate price:", error);
      }
    };

    fetchCertificatePrice();
  }, []);

  const totalPrice = quantity * certificatePrice;

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!buyerName || !email || quantity < 1) {
      toast.error("Uzupełnij wszystkie pola");
      return;
    }

    setIsSubmitting(true);

    try {
      const orderResponse = await apiMongo.post(
        `${process.env.REACT_APP_MONGO_URL}/game/donation`,
        { buyerName, email, quantity }
      );

      const paymentResponse = await apiMongo.post(
        `${process.env.REACT_APP_MONGO_URL}/payment/create_payment`,
        {
          orderId: orderResponse.data.order._id,
          customerEmail: email,
        }
      );

      window.location.href = paymentResponse.data.paymentUrl;
    } catch (error) {
      toast.error("Coś poszło nie tak, spróbuj jeszcze raz");
      setIsSubmitting(false);
    }
  };

  return (
    <div className="heroNotGame">
      <div className="support-shelter-page">
        <p className="title is-3 font-antonio">Wesprzyj schronisko 🐾</p>
        <p className="subtitle is-6">
          Kup cyfrowy certyfikat wsparcia — niezależnie od tego, czy grasz w
          MapGame. Każdy certyfikat to realna pomoc dla zwierząt czekających
          na dom.
        </p>
        <p className="support-shelter-note">
          Wartość Twojego certyfikatu pokrywa dodatkowo udział w aktualnej
          rundzie MapGame — wystarczy zagrać, używając tego samego adresu
          email.
        </p>

        <form onSubmit={handleSubmit} className="box">
          <div className="field">
            <label className="label">Imię i nazwisko</label>
            <div className="control">
              <input
                className="input"
                type="text"
                value={buyerName}
                onChange={(e) => setBuyerName(e.target.value)}
                placeholder="Jak podpisać certyfikat?"
                required
              />
            </div>
          </div>

          <div className="field">
            <label className="label">Adres email</label>
            <div className="control">
              <input
                className="input"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Gdzie wysłać certyfikat?"
                required
              />
            </div>
          </div>

          <div className="field">
            <label className="label">Liczba certyfikatów</label>
            <div className="control">
              <input
                className="input"
                type="number"
                min={1}
                value={quantity}
                onChange={(e) =>
                  setQuantity(Math.max(1, Number(e.target.value)))
                }
              />
            </div>
          </div>

          <p className="support-shelter-total">
            Do zapłaty: <strong>{totalPrice.toFixed(2)} zł</strong>
          </p>

          <button
            type="submit"
            className="button is-primary is-fullwidth"
            disabled={isSubmitting}
          >
            {isSubmitting ? "Przetwarzanie..." : "Przejdź do płatności"}
          </button>
        </form>
      </div>
    </div>
  );
};
